<template>
  <span
    :id="rootId"
    class="info-hint"
  >
    <button
      ref="button"
      type="button"
      class="info-hint__button"
      :aria-label="text"
    >
      <LucideIcon
        name="info"
        :size="14"
      />
    </button>
    <b-popover
      :target="() => $refs.button"
      :container="rootId"
      triggers="hover focus"
      placement="top"
      boundary="viewport"
      custom-class="info-hint__popover"
    >
      {{ text }}
    </b-popover>
  </span>
</template>

<script>
import LucideIcon from './LucideIcon.vue';

export default {
  name: 'InfoHint',
  components: {
    LucideIcon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rootId: `info-hint-${this._uid}`,
    };
  },
};
</script>

<style lang="scss" scoped>
.info-hint {
  display: inline-flex;
  flex-shrink: 0;

  &__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #64748b;
    line-height: 1;

    &:hover,
    &:focus,
    &[aria-describedby] {
      background: #189a73;
      color: #fff;
      outline: none;
    }
  }

  ::v-deep .info-hint__popover {
    max-width: 220px;
    border-color: #e2e8f0;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
    font-size: 12px;
    line-height: 16px;

    .arrow {
      display: none;
    }

    .popover-body {
      padding: 8px 10px;
      color: #0f172a;
    }
  }
}
</style>
